<template>
  <div>
    <span class="display_id" v-if="project.shortId"
    ><span>Project ID:</span> {{ project.shortId }}</span
    >

    <h6 :class="{ spaced: project.shortId }">Main Information</h6>
    <material-input
      v-model="project.name"
      type="text"
      label="Project Name*"
      :required="false"
      name="ProjectName"
      :maxChars="60"
    />
    <material-input
      v-model="project.description"
      type="textarea"
      label="Project Description"
      :required="false"
      name="ProjectDescription"
    />

    <h6 class="spaced">Project Status</h6>
    <dropdown
      :options="status_options"
      :value="project.status"
      :onChange="val => (project.status = val)"
      placeholder="Status"
    />

    <h6 class="spaced">Time Estimate</h6>
    <div class="grid">
      <div class="datepicker dense">
        <label>Start date</label>
        <datepicker
          :value="project.startDate"
          mode="single"
          :onChange="updateStartDate"
          placeholder="Select date"
          class="datepicker"
          :maxDate="maxDate"
        />
      </div>

      <div class="datepicker dense">
        <label>End date</label>
        <datepicker
          :value="project.dueDate"
          mode="single"
          :onChange="updateDueDate"
          placeholder="Select date"
          class="datepicker"
          :minDate="minDate"
        />
      </div>
    </div>
    <div v-if="project.startDate && project.dueDate">
      <dropdown
        class="mb-4"
        :options="effort_options"
        :value="project.effort"
        :onChange="val => (project.effort = val)"
        placeholder="Effort Required"
      />
    </div>


    <h6>Additional Information</h6>
    <div class="grid">
      <dropdown
        :options="currencyOptions"
        :value="project.currencyId"
        :onChange="updateCurrency"
        placeholder="Currency*"
      />

<!--      <dropdown-->
<!--        :options="category_options"-->
<!--        :value="project.categoryId"-->
<!--        :onChange="val => (project.categoryId = val)"-->
<!--        placeholder="Team"-->
<!--      />-->

      <material-input
        v-model="project.estAnnualSpend"
        type="number"
        :label="`Total Project Spend`"
        :required="false"
        name="EstAnnualSpend"
        :symbol="getCurrencySymbol()"
      />

      <CategorySelect
        :categories="categories"
        :value="project.categoryId"
        :required="true"
        @change="project.categoryId = $event"
      />


        <toggle-button
          v-if="userIsProjectMember"
          label="Private Project"
          :value="project.private"
          :onChange="() => (project.private = !project.private)"
        />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import MaterialInput from './MaterialInput.vue';
import Dropdown from './Dropdown';
import Datepicker from './Datepicker';
import moment from 'moment';
import currSymbol from 'currency-symbol-map';
import {mapGetters} from 'vuex';
import ToggleButton from './ToggleButton';
import CategorySelect from "@/components/CategorySelect";

export default {
  name: 'ProjectModal_Details',
  props: {
    project: Object,
  },
  components: {
    CategorySelect,
    'material-input': MaterialInput,
    dropdown: Dropdown,
    datepicker: Datepicker,
    ToggleButton
  },
  methods: {
    getCurrencySymbol() {
      return currSymbol(this.currencyCodeById(this.project.currencyId));
    },
    updateDate(date, key) {
      if (date) {
        const new_date = moment(date, [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);
        const old_date = moment(this.project[key], [
          'DD MMM YYYY',
          'YYYY-MM-DD',
          'YYYY-MM-DDTHH:mm:ss:SSSZ',
        ]);

        if (new_date && old_date && !new_date.isSame(old_date, 'd')) {
          Vue.set(this.project, key, new_date.toISOString());
        }
      } else {
        Vue.set(this.project, key, null);
      }
    },
    updateStartDate(date) {
      this.updateDate(date, 'startDate');
    },
    updateDueDate(date) {
      this.updateDate(date, 'dueDate');
    },
    async updateCurrency(val) {
      if(this.project.currencyId === val) return;
      if(this.project.id  && (this.project.estAnnualSpend > 0 || this.project.projectBenefits.length > 0)) {
        try {
          const options = {
            html: false,
            okText: 'Continue',
            cancelText: 'Cancel',
            customClass: 'acada-confirm',
            animation: 'fade',
          };
          const message = {
            title: 'Currency Change',
            body: `This project contains Spend or Benefits. Please be sure to adjust their values when making changes to the project currency.`,
          };

          await this.$dialog.confirm(message, options);
        } catch (e) {
          // they clicked cancel, so don't change the currency
          return;
        }
      }
      this.project.currencyId = val;
    }
  },
  computed: {
    ...mapGetters(['currencies', 'currencyCodeById', 'conversionRates']),
    app_user() {
      return this.$store.getters.app_user || {};
    },
    userIsProjectMember() {
      return this.project && Array.isArray(this.project.projectMembers) && (this.project.projectMembers.reduce((arr, projectMember) => [...arr, projectMember.id], []).includes(this.app_user.id));
    },
    currencyOptions() {
      return this.currencies
        .filter(currency => !!this.conversionRates[currency.id])
        .map(currency => ({
          text: currency.code,
          value: currency.id,
        }));
    },
    categories() {
      return this.$store.getters.categories;
    },
    category_options() {
      return Object.keys(this.categories).map(key => {
        const cat = this.categories[key];
        return {value: cat.id, text: cat.name};
      });
    },
    // sub_category_options(){
    //   const selectedCategory = this.project.categoryId
    //   if(!selectedCategory) return undefined;
    //
    //   return this.categories[selectedCategory] ? this.categories[selectedCategory].subCategories() : undefined
    // },
    minDate() {
      let date = null;
      if (this.project && this.project.startDate) {
        date = moment(this.project.startDate).toDate();
      }
      return date;
    },
    maxDate() {
      let date = null;
      if (this.project && this.project.dueDate) {
        date = moment(this.project.dueDate).toDate();
      }
      return date;
    },
  },
  watch: {
    userIsProjectMember(newVal) {
      if (!newVal && this.project.private) {
        this.project.private = false
      }
    }
  },
  data() {
    return {
      status_options: [
        {value: 'Active', text: 'Active'},
        {value: 'Completed', text: 'Completed'},
        {value: 'On hold', text: 'On hold'},
        {value: 'Pipeline', text: 'Pipeline'},
        {value: 'Cancelled', text: 'Cancelled'},
      ],
      effort_options: [
        {value: 0.05, text: 'Low (Two Hours a week)' },
        {value: 0.2, text: 'Medium (One day a week)' },
        {value: 0.4, text: 'High (Two days a week)' },
        {value: 0.8, text: 'Very High (Four days a week)' }
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.display_id {
  border-radius: 4px;
  background: rgba(210, 216, 222, 0.54);
  padding: 7px 10px 9px;
  font-size: 13px;

  span {
    color: #929da9;
  }
}

.grid {
  .material-input {
    //margin-top: 20px;
    width: 215px;
  }

  .toggle-button {
    margin-top: 20px;
    margin-left: 0;
    width: 215px;
  }
}

.my-tooltip {
  z-index: 9999 !important;
}
</style>
